module.exports = __webpack_public_path__ + "media/components/src/assets/images/icons/icon-graduation-7e06f444953bd1d238e1ae4fc5c5b0a3.png";